/** 消费券 */
export interface VoucherItem {
  /** 券批次状态 */
  cvStatus: VoucherStatus
  /** 消费券状态 */
  transState: VoucherTransState
  /** 消费券转移状态 */
  ownState: VoucherOwnState
  /** 余额 */
  balance: string
  /** 创建时间 */
  createTime: string
  /** 有效期 */
  validTime: string
  /** 过期时间 */
  expireTime: string
  /** 用户券ID */
  userCvId: string
  /** 券批次号 */
  cvId: string
  /** 券logo */
  cvIcon: string
  /** 券描述 */
  cvName: string
  /** 券描述 */
  cvDesc: string
  /** 券类型 */
  cvType: VoucherType
  /** 是否推荐该券 */
  recommend: string
  /** 若是主动领取消费券，则该字段是点击领取的时间，被动领取与FcreateTime相同。 */
  receiveTime: string
  /** 修改时间 */
  modifyTime: string
  /** 累积实际撤回金额 */
  releaseAmount: string
  /** 废除渠道 */
  deleteChannel: string
  /** 累计已使用金额 */
  totalUsedBal: string
}

/** 券批次状态 */
export enum VoucherStatus {
  /** 预派发 */
  PRE_SEND = '1',
  /** 派发成功 */
  RECEIVED = '2',
  /** 下线 */
  OFFLINE = '3',
}

/** 消费券状态 */
export enum VoucherTransState{
  USING = '1',
  ABANDON = '2',
  TRANS = '3',
  GOV_RECALL = '91',
  GOV_CALLBACK = '92'
}

/** 消费券转移状态 */
export enum VoucherOwnState{
  /** 初始状态 */
  INIT = '1',
  /** 转移/转赠中 */
  TRANS_ING = '2',
  /** 转移/转增完成（对方点击领取） */
  TRANS_RECEIVED = '3'
}

/** 消费券类别 */
export enum VoucherType{
  GOV = '4001',
  PROM = '4002'
}

/** 消费券列表请求接口type类型 */
export enum ListParamType{
  NORMAL = 1,
  EXPIRED = 2,
  REFUND = 4,
}

export enum EntryEnum{
  VALID = '1',
  INVALID = '2'
}
